export default {
  signature: "profile/signature",
};
